function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "map-pin (1)",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 159",
    d: "M19.364 9.182c0 6.363-8.182 11.818-8.182 11.818S3 15.545 3 9.182a8.182 8.182 0 0 1 16.364 0z",
    style: {
      fill: "none",
      stroke: "#6c7b8b",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 35",
    cx: 2.727,
    cy: 2.727,
    r: 2.727,
    transform: "translate(8.455 6.455)",
    style: {
      fill: "none",
      stroke: "#6c7b8b",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.be17b84461670ed76f0bed8e011a4ee6.svg";
export { ForwardRef as ReactComponent };